


































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import VLazyImage from 'v-lazy-image';

@Component({
  name: 'Banner',
  components: {
    VLazyImage,
  },
})
export default class Banner extends Vue {
  @Prop(String) public readonly title!: string;
  @Prop(String) public readonly description!: string;
  @Prop(String) public readonly btnName!: string;
  @Prop(String) public readonly btnLink!: string;
  @Prop(String) public readonly moreInfoLink?: string;
  @Prop({ type: Number, default: 480 }) public readonly height?: number;
  @Prop(String) public readonly moreInfo?: string;
  @Prop(Object) public readonly imgSrc!: {};
  // TODO: create page translation
  // TODO: image size + image file with width
  private get srcImg(): string {
    // TIP: return empty string for stub error in console,
    //      this is bug by typecheking from v-lazy-image
    return this.imgSrc && `${this.imgSrc[3600]}` || '';
  }

  private get srcImgPlaceholder(): string {
    return this.imgSrc && `${this.imgSrc[400]}`;
  }

  private get srcSet(): string {
    return this.imgSrc && `${this.imgSrc[400]} 400w, ${this.imgSrc[800]} 800w,
      ${this.imgSrc[1300]} 1300w, ${this.imgSrc[1900]} 1900w, ${this.imgSrc[3600]} 3600w`;
  }

  public goTo(link: string): void {
    this.$router.push(link);
  }
}
